import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH_REPORT;

export const postUploadFileToDB = params =>
  axios.post(
    `${API_HOST}/api/statistics/upload-file`,
    JSON.stringify({
      files: params
    }),
    {
      headers: {
        'Content-Type': 'application/json'
      },
      mode: 'no-cors'
    }
  );

export const getUploadFileToDB = params =>
  axios.get(`${API_HOST}/api/statistics/upload-file`, params, {
    withCredentials: true
  });

export const getStatisticsCompareData = params =>
  axios.get(`${API_HOST}/api/statistics/compare`, params, {
    withCredentials: true
  });

export const postStatisticsGochiData = params =>
  axios.post(`${API_HOST}/api/statistics/gochi/run`, {
    params,
    withCredentials: true
  });

export const postStatisticsImportData = params =>
  axios.post(`${API_HOST}/api/statistics/import/run`, {
    params,
    withCredentials: true
  });

export const downloadCSVData = () =>
  axios.get(`${API_HOST}/api/statistics/export`, {
    headers: {
      'Content-Type':
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    responseType: 'arraybuffer'
  });

export const getStatisticGochiStatusData = params =>
  axios.get(`${API_HOST}/api/statistics/gochi/status`, params, {
    withCredentials: true
  });

export default postUploadFileToDB;
